import { Label, inputCls } from "./shared";

export function MiningXpCurveEditor({
  curveLevels,
  importValue,
  onImportChange,
  onLoadImport,
  onPatchLevel,
  onResetCurrent,
  onLoadDefault,
  onApply,
  saving,
}) {
  return (
    <section data-testid="admin-mining-xp-curve-section" className="border border-zinc-800 bg-zinc-950/60 p-4 rounded-sm space-y-4">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <h3 data-testid="admin-mining-xp-curve-title" className="font-cinzel uppercase tracking-widest text-sm text-amber-300">Mining XP Curve</h3>
          <p data-testid="admin-mining-xp-curve-help" className="text-sm text-zinc-500 mt-2">
            Set the cumulative total XP needed for each Mining level. Level 1 must stay at 0, and each later level must stay the same or go higher.
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          <button data-testid="admin-mining-xp-curve-reset-current" type="button" onClick={onResetCurrent} className="px-4 py-2 text-sm border border-zinc-700 text-zinc-200 hover:bg-zinc-900/80">Reset to Current</button>
          <button data-testid="admin-mining-xp-curve-load-default" type="button" onClick={onLoadDefault} className="px-4 py-2 text-sm border border-zinc-700 text-zinc-200 hover:bg-zinc-900/80">Load Default Curve</button>
          <button data-testid="admin-mining-xp-curve-apply" type="button" onClick={onApply} disabled={saving} className="px-5 py-2 font-cinzel uppercase tracking-wide text-sm rounded-sm border border-amber-600 text-amber-300 hover:bg-amber-900/30 disabled:opacity-50">
            {saving ? "Applying…" : "Apply Curve"}
          </button>
        </div>
      </div>

      <div className="grid lg:grid-cols-[minmax(0,1fr)_22rem] gap-4 items-start">
        <div>
          <Label>Per-level total XP requirements</Label>
          <div data-testid="admin-mining-xp-curve-grid" className="mt-2 grid sm:grid-cols-2 xl:grid-cols-4 gap-3 max-h-[28rem] overflow-y-auto pr-1">
            {curveLevels.map((entry) => (
              <div key={entry.level} className="border border-zinc-800 bg-zinc-950/70 p-3 rounded-sm">
                <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-2">Level {entry.level}</div>
                <input
                  data-testid={`admin-mining-xp-level-${entry.level}`}
                  type="number"
                  min="0"
                  step="1"
                  value={entry.total_xp}
                  onChange={(e) => onPatchLevel(entry.level, e.target.value)}
                  className={inputCls}
                />
              </div>
            ))}
          </div>
        </div>

        <div className="space-y-2">
          <Label>Paste or import a full curve</Label>
          <textarea
            data-testid="admin-mining-xp-curve-import"
            value={importValue}
            onChange={(e) => onImportChange(e.target.value)}
            className={`${inputCls} min-h-[16rem] font-mono text-xs`}
            placeholder="Paste 100 values separated by commas, spaces, or new lines. First value = level 1 total XP (must be 0)."
          />
          <button data-testid="admin-mining-xp-curve-load-import" type="button" onClick={onLoadImport} className="w-full px-4 py-2 text-sm border border-zinc-700 text-zinc-200 hover:bg-zinc-900/80">
            Load Pasted Curve Into Editor
          </button>
          <p data-testid="admin-mining-xp-curve-import-help" className="text-xs text-zinc-500">
            Tip: export or edit the whole curve quickly here, then press <span className="text-zinc-300">Apply Curve</span> once.
          </p>
        </div>
      </div>
    </section>
  );
}